<template>
  <div class="notice">
    <div class="header">
      <p class="header_title">{{ title }}</p>
      <div class="header_tag">
        <p>发布时间：{{ ctime | formatDate(ctime)}}</p>
        <p>作者：{{ author }}</p>
        <p>查看次数：{{ count }}次</p>
      </div>
    </div>
    <div class="main">
      <p v-html="content"></p>
    </div>
  </div>
</template>

<script>
import { httpNoticeCat } from "../../utils/home";
import { formatDate } from "../../filters/filters.js";

export default {
  data() {
    return {
      title: "",
      ctime: "",
      author: "",
      count: "",
      content: "",
    };
  },
  methods: {
    _httpNoticeCat(id) {
      httpNoticeCat(id).then((res) => {
        let data = res.data;
        if (data.code == 0) {
          this.title = data.data.title;
          this.ctime = data.data.ctime;
          this.author = data.data.author;
          this.count = data.data.count;
          this.content = data.data.content;
        } else {
          this.$message(data.msg);
        }
      });
    },
  },
  filters: {
    formatDate(time) {
      var data = new Date(time * 1000);
      return formatDate(data, "yyyy-MM-dd hh:mm:ss");
    },
  },
  mounted() {
    this._httpNoticeCat(this.$route.query.id);
  },
};
</script>

<style lang="scss" scoped>
.notice {
  width: 100%;
  .header {
    text-align: center;
    margin: 0 auto;
    height: 80px;
    border-bottom: 1px solid #999999;
    .header_title {
      font-weight: bolder;
      margin-bottom: 20px;
    }
    .header_tag {
      display: flex;
      justify-content: center;
      p {
        margin: 0 20px;
      }
    }
  }
  .main {
    margin-top: 30px;
    p {
      height: 50px;
      line-height: 50px;
    }
  }
}
</style>